import { memo, useEffect, useMemo } from "react";

import { Button, Row, TextInput } from "@narmi/design_system";
import { modules } from "byzantine";

import * as formAdapters from "../../../adapters/index";

import type { CommonProps } from "./types";

type Props = CommonProps & {
  questions: API.NPS.FreeFormQuestion[];
  showBackButton: boolean;
};

const FreeFormQuestions = ({
  questions: freeFormQuestions,
  showBackButton,
  setMode,
  close,
  setFooter,
}: Props) => {
  const { form, loading, submit } = modules.nps.useSubmitAnswers(close);
  const questions = modules.nps.useFreeFormQuestions(freeFormQuestions);
  const buttonLabels = modules.nps.useButtonLabels();

  const footer = useMemo(() => {
    return (
      <Row className="margin--top--l" justifyContent="end">
        <Row.Item shrink>
          {showBackButton ? (
            <Button
              kind="plain"
              isLoading={loading}
              onClick={() => setMode("npsscore")}
              label={buttonLabels.back}
            />
          ) : null}
        </Row.Item>
        <Row.Item shrink>
          <Button
            isLoading={loading}
            onClick={submit}
            label={buttonLabels.submit}
          />
        </Row.Item>
      </Row>
    );
  }, [
    buttonLabels.back,
    buttonLabels.submit,
    loading,
    setMode,
    showBackButton,
    submit,
  ]);

  useEffect(() => {
    setFooter(footer);
  }, [footer, setFooter]);

  return (
    <>
      {questions.map(({ question, label }) => {
        const adapter = formAdapters.input(form, question.uuid);
        return (
          <div key={question.uuid}>
            <div className="margin--y--m">{question.text}</div>
            <TextInput multiline {...adapter} label={label} />
          </div>
        );
      })}
    </>
  );
};

export default memo(FreeFormQuestions);
